// import { Events } from "./events";

import { Network } from './network'

class Chat {
  static async init() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    window.chatIsOpened = false
    const config = await downloadChatConfig()
    console.log(config)
    dynamiclyInsertChatScript(config.baseUrl, config.websiteToken)
    setTimeout(Chat.additiannalInitiation, 5000)
    setTimeout(Chat.listenChatEvents, 5000)
  }

  static additiannalInitiation() {}

  static listenChatEvents() {
    setInterval(() => {
      if (window.chatIsOpened) {
        const isOpened = Chat.isOpened()
        if (!isOpened) Events.dispatchEvent('on_chat_closed')
      } else {
        const isOpened = Chat.isOpened()
        if (isOpened) Events.dispatchEvent('on_chat_opened')
      }
    }, 1000)

    // window.$chatwoot?.on("widget:opened", function() {
    //   Events.dispatchEvent("on_chat_opened");
    //   window.chatIsOpened = true;
    // });
    // window.$chatwoot?.on("widget:closed", function() {
    //   Events.dispatchEvent("on_chat_closed");
    //   window.chatIsOpened = false;
    // });
  }

  static setUserData(user, appData, userPreferences) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    const config = {
      name: `${user.firstName} ${user.lastName}`,
      email: user.email,
    }
    window.$chatwoot?.setUser(config.email, config)
  }

  static openChat() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    window.$chatwoot?.toggle('open')
  }

  static closeChat() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    window.$chatwoot?.toggle('close')
  }

  static disconnectUser() {
    window.$chatwoot?.reset()
  }

  static isOpened() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return false
    window.chatIsOpened = window.$chatwoot?.isOpen
    return window.chatIsOpened
  }
}

function dynamiclyInsertChatScript(baseUrl, websiteToken) {
  const script = `
  (function(d,t) {
    var BASE_URL="${baseUrl}";
    var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
    g.src=BASE_URL+"/packs/js/sdk.js";
    g.defer = true;
    g.async = true;
    s.parentNode.insertBefore(g,s);
    g.onload=function(){
      window.chatwootSDK.run({
        websiteToken: '${websiteToken}',
        baseUrl: BASE_URL
      })
    }
  })(document,"script");
  `

  const scriptTag = document.createElement('script')
  scriptTag.setAttribute('type', 'text/javascript')
  scriptTag.innerHTML = script
  document.body.appendChild(scriptTag)
}

async function downloadChatConfig() {
  const url = 'https://apis.1xpay.co/chat/fetch/config/kingrecharge'
  const res = await Network.sendGetRequest(url)
  if (res?.status?.code !== 200) return null
  console.log(res)
  const config = {
    baseUrl: res?.response?.data?.baseUrl,
    websiteToken: res?.response?.data?.websiteToken,
  }
  return config
}

export { Chat }
